import React, { lazy, Suspense } from 'react'
import { Spinner, Modal } from 'react-bootstrap'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import download from 'downloadjs'
import 'pure-react-carousel/dist/react-carousel.es.css'
import JSZip from 'jszip'
import { API_ROOT } from '../constants'
import ConfirmationModal from '../components/ConfirmationModal'
import DomainExistsModal from '../components/DomainExistsModal'
import {
  toggleModal,
  accountModal,
  actionProcessing,
  fetchUserData,
  fetchDeletedSites,
  hideMessageModal,
  showCreateSiteModal,
  showMessageModal,
  showUpgradeModal as showSubscribeModal,
  toggleTeamModal,
  toggleSelectTeamOwnerModal,
  setFirstTimeSuccModal,
  setQrCodeModal,
  setQrCodeData,
  setDraggedFile,
  setPreviewModal,
  setPreviewData,
  setEmbedData,
  setSiteType,
  showCustomDomainModal,
  showEmailSubscriptionModal,
  customDomainDiagnostics,
  setAccountPasswordModal,
  showDropboxModal
} from './actions'
import { showAnalyticsModal, showHtmlAnalysisModal } from '../actions'
import HomeHeader from './components/Header/Header'
import ManageAccountModal from '../components/ManageAccountModal'
import {
  hasFeature,
  onUpgradePlan,
  pluralize,
  getFileFromIndexedDB,
  isWasmerFile,
  isOnFreeTrial,
  addUpgradeReason
} from '../utils/general'
import MessageModal from '../components/MessageModal'
import api from '../utils/api'
import FileListModal from '../components/FileListModal/FileListModal'
import AnalyticsModal from '../components/Analytics/AnalyticsModal/AnalyticsModal'
import EmbedModal from '../components/EmbedModal/EmbedModal'
import { downloadSite } from '../services/manage'
import { getChatSignature } from '../services/support'
import { executeDownloadAll } from './handlers/downloadAllHandler'
import UpgradePromoCard from '../components/UpgradePromoModal'
import {
  showUpgradeCardModal,
  setShowPaymentModal,
  UPGRADE_QR_PAYLOAD,
  UPGRADE_FEEDBACK_PAYLOAD,
  UPGRADE_CUSTOM_DOMAIN,
  UPGRADE_VERSIONS_PAYLOAD
} from '../actions'
import { formatWasmerRecords } from '../components/CustomDomainModal/PhpCustomDomainModal'
import ProPlansModal from '../components/ProPlans/ProPlansModal'
import { PLANS, PLANS_ID, ARCHIVE_LIMIT_FREE_PLAN } from '../constants/plans'
import { trackUpload } from '../utils/analytics'
import AddTeamMembersModal from './components/AddTeamMembersModal/AddTeamMembersModal'
import DragWrapper from 'components/DragAndDrop/DragWrapper'
import QRCodeModal from 'components/QRCodeModal/QRCodeModal'
import PDFEditorModal from '../components/PDFEditor/PDFEditor'
import FirstTimeSucessModal from 'components/SuccessBox/FirstTimeSuccessModal'
import { F_CUSTOM_DOMAIN, F_EDIT_MODE } from '../constants/plans/constants'
import BandwidthAlert from './components/BandwidthAlert/BandwidthAlert'
import RepoModal from 'components/GithubRepo/Repo'
import { openGithubConnect, isGithubConnected } from 'utils/github'
import { getAddToCalHTML } from '../utils/AddToCal'
import PreviewModal from 'components/PreviewModal/PreviewModal'
import CreateUpdateSiteModal from 'components/CreateUpdateSiteModal'
import EmailSubscriptionModal from '../components/EmailSubscription/EmailSubscriptionModal'
import { ACTION_CREATE, ACTION_UPDATE } from '../components/CreateUpdateSiteModal/interface'
import Refund from 'Refund'
import DiscountBanner from './components/DiscountBanner/DiscountBanner'
import AIPlatformBanner from './components/AIPlatformBanner/AIPlatformBanner'
import { openPricingPopup, uploadedFileTooBig } from 'utils/sendy'
import PlanPaymentModal from 'components/PlanPaymentModal/PlanPaymentModal'
import DEEP_LINK from '../utils/deepLinks'
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3'
import ClaimSiteModal from './components/ClaimSiteModal/ClaimSiteModal'
import AccountPasswordModal from 'components/ManageAccountModal/components/AccountPasswordModal'
import APIWelcomeModal from '../components/APIWelcomeModal/APIWelcomeModal'
import ArchiveDeleteModal from '../components/ArchiveDeleteModal'
import FeedbackCallModal from 'components/FeedbackCallModal/FeedbackCallModal'
import ReplaceUpgradeModal from 'components/ReplaceUpgradeModal'
import SubscriptionPausedAlert from './components/SubscriptionPausedAlert/SubscriptionPausedAlert'
import SubscriptionSuspendedModal from './components/SubscriptionSuspendedModal/SubscriptionSuspendedModal'
import PastDuePaymentModal from './components/PastDuePaymentModal/PastDuePaymentModal'
import TrackedLinkCreateModal from 'components/TrackedLinks/Sharing/TrackedLinkCreateModal'
import HtmlAnalysisModal from 'components/HtmlAnalysisModal/HtmlAnalysisModal'
import ProcessingFilesAlert from './components/ProcessingFilesAlert/ProcessingFilesAlert'
import GlobalTiinyReceiver from 'ClientSideAPI/TiinyWidgetReceiver'
import analyticsTypes from '../enums/analytics/analyticsTypes'
import DropboxConnector from 'components/DropboxConnector/DropBoxConnector'
import ProjectViews from './components/ProjectViews/ProjectViews'
import OptionsModal from 'components/OptionsModal/OptionsModal'
import FreeTrialModalContainer from '../components/FreeTrialModal/FreeTrialModalContainer'
import AICreatorBanner from '../components/AICreatorBanner/AICreatorBanner'
import { TransferRequestLinkModal } from 'components/TransferRequestLink/TransferRequestLinkModal'
import JoinTeamBanner from '../components/JoinTeamBanner/JoinTeamBanner'
import GameShowcaseBanner from '../components/GameShowcaseBanner/GameShowcaseBanner'
import GameShowcaseModal from '../components/GameShowcaseModal/GameShowcaseModal'
import { getGameShowcaseStatuses, getEligibleGameSitesKey, getUnsubmittedEligibleGameSites } from '../services/games'
import SelectTeamOwnerModal from '../components/SelectTeamOwnerModal/SelectTeamOwnerModal'
import VersionsModal from './components/VersionsModal/VersionsModal'
import { getSiteVersions, rollbackSiteVersion } from '../services/site'
import ProjectSelectorModal from '../components/CustomDomainModal/components/ProjectSelectorModal'
import UpgradePromptModal from '../components/CustomDomainTable/components/UpgradePromptModal'

const TextEditor = lazy(() => import('../components/TextEditor/TextEditor.js'))
const CodeEditor = lazy(() => import('../components/CodeEditor/CodeEditor'))

import './Manage.css'

const ACTION_ARCHIVE = 'ARCHIVE'
const ACTION_DELETE = 'DELETE'
const ACTION_DELETE_ARCHIVE = 'ARCHIVE/DELETE'
const ACTION_RESTORE_ARCHIVE = 'ARCHIVE/RESTORE'
const ACTION_RESTORE_DELETED = 'RESTORE_DELETED'
const ACTION_PERMANENT_DELETE = 'DELETE/PERMANENT'
const ACTION_DELETE_ACCOUNT = 'DELETE/ACCOUNT'
const ACTION_DOWNLOAD = 'DOWNLOAD'
const ACTION_SHARE = 'SHARE'

class Manage extends React.Component {
  state = {
    isLoading: true,
    downloadAllProcessing: false,
    showVersionsModal: false,
    showVersionsTrialUpgrade: false,
    versionsLoading: false,
    versionsRollbackProcessing: false,
    versionsData: [],
    activeVersionId: null,
    selectedVersionId: null,
    versionsSite: null,
    showDomainUpdateModal: false,
    domainToUpdate: null,
    gameShowcaseSites: [],
    gameShowcaseStatuses: {}
  }

  gameShowcaseSitesKey = ''

  refreshGameShowcaseStatuses = async () => {
    const statuses = await getGameShowcaseStatuses(this.props.liveSites)
    this.setState({ gameShowcaseStatuses: statuses })
  }

  componentDidMount() {
    if (localStorage.getItem('token')) {
      this.refreshProfile()

      const urlParams = new URLSearchParams(window.location.search)
      const gptDomain = urlParams.get('gpt-domain')

      if (gptDomain) {
        // Set the site state based on gptDomain
        this.setState({
          showClaimSiteModal: true // Show the ClaimSiteModal
        })
      }

      const redirectUrl = localStorage.getItem('redirect-url')
      if (redirectUrl) {
        localStorage.removeItem('redirect-url')
        window.location = redirectUrl
      }

      const planId = localStorage.getItem('planId')
      if (planId) {
        localStorage.removeItem('planId')
        this.props.history.replace({
          pathname: '/manage/subscription/upgrade',
          search: planId ? `?planId=${planId}` : ''
        })
      }
      this.checkGithubModal()
    } else {
      localStorage.setItem('redirect-url', window.location.href)
      window.location = '/login'
    }
  }

  componentDidUpdate(prevProps) {
    const eligibleGameSitesKey = getEligibleGameSitesKey(this.props.liveSites)
    if (eligibleGameSitesKey !== this.gameShowcaseSitesKey) {
      this.gameShowcaseSitesKey = eligibleGameSitesKey
      this.refreshGameShowcaseStatuses()
    }

    if (prevProps?.userProfile?.email !== this.props?.userProfile?.email) {
      const { email, productId } = this.props.userProfile
      const plan = PLANS_ID[productId]?.label || 'Free'

      // Save email to localStorage for pre-filling login form
      if (email) {
        localStorage.setItem('savedEmail', email)
      }

      if (window.$crisp) {
        window.$crisp.push([
          'set',
          'session:data',
          [
            'profile',
            `https://tiiny.retool.com/apps/58d613a4-dcbd-11f0-a0a1-071dbfdb0cba/User%20Profile?email=${email}`
          ]
        ])
        window.$crisp.push(['set', 'session:data', ['customer-plan', plan]])

        this.setCrispEmailWithSignature(email)
      }

      const urlParams = new URLSearchParams(window.location.search)

      // track only if first
      const first = urlParams.get('first')
      if (first === 'true') {
        if (this.props.liveSites.length === 1) {
          const site = this.props.liveSites[0]

          trackUpload(plan, site?.size, site?.type, email)

          if (site?.inPreviewMode) {
            uploadedFileTooBig()
            this.props.history.push(DEEP_LINK.PREVIEW_MODE)
            this.props.dispatch(setPreviewModal(true))
            this.props.dispatch(setPreviewData(site))
          } else {
            const { userCategory } = this.props.userProfile
            const isB2BUser = userCategory === 'B2B'

            if (!isB2BUser || !productId) {
              this.props.dispatch(setFirstTimeSuccModal({ showFistTimeSuccModal: true, firstTimeSite: site }))
            }
          }
        }
        localStorage.setItem('isFirstTimeUpload', 'true')

        urlParams.delete('first')
        this.props.history.replace({
          pathname: '/manage',
          search: urlParams.toString()
        })
      }

      const ref = urlParams.get('ref')
      if (ref === 'invite') {
        const addToCalConfig = localStorage.getItem('addToCalConfig')
        localStorage.removeItem('addToCalConfig')
        const htmlContent = getAddToCalHTML(JSON.parse(addToCalConfig))
        const inviteFile = new File([htmlContent], 'invite.html', {
          type: 'text/html',
          lastModified: new Date(),
          path: 'invite.html'
        })
        this.props.dispatch(setDraggedFile(inviteFile))
        this.onSiteAction(ACTION_CREATE)
      } else if (ref === 'test-html') {
        const retrievedHTML = localStorage.getItem('html-code')
        const retrievedCSS = localStorage.getItem('css-code')
        const retrievedJS = localStorage.getItem('js-code')

        if (retrievedHTML) {
          const zip = new JSZip()
          zip
            .folder('html')
            .file('index.html', retrievedHTML)
            .file('main.css', retrievedCSS)
            .file('main.js', retrievedJS)

          zip
            .generateAsync({ type: 'blob' })
            .then((result) => {
              let file = new File([result], 'html.zip', {
                type: 'application/zip',
                lastModified: new Date(),
                path: 'html.zip'
              })

              // clean up
              localStorage.removeItem('html-code')
              localStorage.removeItem('css-code')
              localStorage.removeItem('js-code')

              this.props.dispatch(setDraggedFile(file))
              this.onSiteAction(ACTION_CREATE)
            })
            .catch((err) => console.error(err))
        }
      } else if (ref === 'online-pdf-viewer') {
        getFileFromIndexedDB()
          .then((pdfFile) => {
            if (pdfFile) {
              this.props.dispatch(setDraggedFile(pdfFile))
              this.onSiteAction(ACTION_CREATE)
            }
          })
          .catch((error) => {
            console.error('Error retrieving PDF from IndexedDB:', error)
          })
      }

      this.handleDeepLinking()
    }
    if (prevProps.location.search !== this.props.location.search && this.props?.userProfile?.email) {
      this.checkGithubModal()
    }
  }

  setCrispEmailWithSignature = async (email) => {
    if (!email || !window.$crisp) {
      return
    }

    try {
      const { signature } = await getChatSignature(email)

      if (signature) {
        window.$crisp.push(['set', 'user:email', [email, signature]])
      } else {
        window.$crisp.push(['set', 'user:email', email])
      }
    } catch (error) {
      console.error('Failed to set Crisp email with signature:', error)
      window.$crisp.push(['set', 'user:email', email])
    }
  }

  handleJoinRequestMagicLink = () => {
    const { dispatch, userProfile, history } = this.props
    if ([PLANS.PRO_U.id, PLANS.PRO_MAX.id].includes(userProfile?.productId)) {
      dispatch(toggleTeamModal(true))
      history.replace({ pathname: '/manage' })
    }
  }

  handleDeepLinking = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const { pathname } = this.props.location
    const { dispatch, liveSites, userProfile, history } = this.props
    const trialAccount = !userProfile.productId

    // Handle magic link for team join requests
    const joinRequestId = urlParams.get('joinRequest')
    if (joinRequestId) {
      this.handleJoinRequestMagicLink(joinRequestId)
      return
    }

    const getSiteFromUrl = () => {
      const siteUrl = urlParams.get('site')
      return liveSites?.find((site) => site.subdomain === siteUrl)
    }

    const actions = {
      [DEEP_LINK.MANAGE_ANALYTICS]: () => {
        const site = getSiteFromUrl()
        if (site) {
          dispatch(showAnalyticsModal({ analyticsType: analyticsTypes.ANALYTICS, site }))
        } else {
          history.replace({ pathname: '/manage' })
        }
      },
      [DEEP_LINK.CHANGE_PLAN]: () => dispatch(accountModal(true)),
      [DEEP_LINK.REACTIVATE_SUB]: () => dispatch(accountModal(true)),
      [DEEP_LINK.MANAGE_ACCOUNT]: () => dispatch(accountModal(true)),
      [DEEP_LINK.CREATE_SITE]: () => this.onSiteAction(ACTION_CREATE),
      [DEEP_LINK.PASTE_HTML]: () => this.setState({ showCodeEditor: true }),
      [DEEP_LINK.WRITE_TEXT]: () => this.onOpenTextEditor(),
      [DEEP_LINK.ADD_CUSTOM_DOMAIN]: () => this.onAddCustomDomain(),
      [DEEP_LINK.CUSTOM_DOMAIN_DIAGNOSTICS]: () => this.customDomainDiagnostics(),
      [DEEP_LINK.PURCHASE_CUSTOM_DOMAIN]: () => this.onAddCustomDomain(),
      [DEEP_LINK.UPDATE_SITE]: () => {
        const site = getSiteFromUrl()
        if (site) {
          dispatch(setDraggedFile(null))
          dispatch(toggleModal(true))
          this.onSiteAction(ACTION_UPDATE, site)
        } else {
          history.replace({ pathname: '/manage' })
        }
      },
      [DEEP_LINK.SHARE]: () => {
        const site = getSiteFromUrl()
        if (site && !trialAccount) {
          this.onOptionModal(site, ACTION_SHARE)
        } else {
          history.replace({ pathname: '/manage' })
        }
      },
      [DEEP_LINK.QR]: () => {
        const site = getSiteFromUrl()
        this.onQRCode(site)
      },
      [DEEP_LINK.EMBED]: () => {
        const site = getSiteFromUrl()
        if (site && !trialAccount) {
          this.onEmbed(site)
        } else {
          history.replace({ pathname: '/manage' })
        }
      },
      [DEEP_LINK.MANAGE_TEAM]: () => {
        const { productId } = userProfile
        if (!productId) {
          dispatch(toggleTeamModal(true))
        } else if ([PLANS.PRO_U.id, PLANS.PRO_MAX.id].includes(productId)) {
          dispatch(toggleTeamModal(true))
        } else {
          onUpgradePlan({ planId: PLANS.PRO_U.id, userProfile }, dispatch)
        }
      },
      [DEEP_LINK.UPGRADE_PLAN]: () => {
        const planId = urlParams.get('planId')

        if (planId) {
          onUpgradePlan({ planId, userProfile }, dispatch)
          return
        }

        if (trialAccount) {
          dispatch(showSubscribeModal(true))
          return
        }

        onUpgradePlan({ planId: userProfile?.productId, userProfile }, dispatch)
      },
      [DEEP_LINK.CANCELLATION]: () => dispatch(accountModal(true)),
      [DEEP_LINK.PREVIEW_MODE]: () => {
        const hasPreviewData = this.props.previewData?.subdomain || this.props.previewData?.link
        if (!hasPreviewData) {
          history.replace({ pathname: DEEP_LINK.MANAGE })
          return
        }
        dispatch(setPreviewModal(true))
      },
      [DEEP_LINK.FEEDBACK_MODE]: () => {
        dispatch(
          showUpgradeCardModal({
            ...UPGRADE_FEEDBACK_PAYLOAD,
            onClick: () => onUpgradePlan({ planId: PLANS.PRO_U.id, userProfile }, dispatch)
          })
        )
      },
      [DEEP_LINK.EMAILS]: () => {
        const domain = urlParams.get('domain')
        if (!domain) {
          history.replace({ pathname: '/manage' })
          return
        }

        this.props.dispatch(showEmailSubscriptionModal(true, domain))
      },
      [DEEP_LINK.SUCCESS]: () => {
        const site = getSiteFromUrl()
        if (site) {
          dispatch(setFirstTimeSuccModal({ showFistTimeSuccModal: true, firstTimeSite: site }))
        } else {
          history.replace({ pathname: '/manage' })
        }
      },
      [DEEP_LINK.DOMAIN_UPDATE]: () => {
        const domain = urlParams.get('site')
        if (!domain) {
          history.replace({ pathname: '/manage' })
          return
        }

        // Trigger the custom domain modal with the specified domain
        // Handle both root domains (link.com) and subdomain custom domains (stuff.link.com)
        const customDomain = this.props.customDomains?.find((d) => {
          const rootDomain = d.domain
          const fullDomain = d.subdomain ? `${d.subdomain}.${d.domain}` : d.domain
          const domainWithoutWww = domain.replace(/^www\./, '')

          return (
            rootDomain === domain ||
            rootDomain === domainWithoutWww ||
            fullDomain === domain ||
            fullDomain === domainWithoutWww
          )
        })

        if (customDomain) {
          this.setState({
            showDomainUpdateModal: true,
            domainToUpdate: customDomain
          })
        } else {
          history.replace({ pathname: '/manage' })
        }
      }
    }

    const action = actions[pathname]
    if (action) {
      action()
    }
  }

  checkGithubModal = () => {
    const searchParams = new URLSearchParams(this.props.location.search)
    const status = searchParams.get('status')
    const isAccessValid = status === 'success'
    isAccessValid && this.onOpenGithubModal()

    if (status === 'failed' && searchParams.get('connect_gh')) {
      this.props.dispatch(
        showMessageModal({
          title: "Couldn't connect GitHub",
          message: searchParams.get('error') || 'Something went wrong while connecting to GitHub. Please try again.',
          error: true
        })
      )
      this.props.history.replace({ pathname: '/manage' })
    }
  }

  onSiteAction = (modalAction, data) => {
    let modalData
    if (data) {
      modalData = {
        ...data,
        domain: data.subdomain
      }
    }

    this.props.dispatch(showCreateSiteModal(true, modalData, modalAction))
  }

  onShowCodeEditor = () => {
    this.setState({ showCodeEditor: true })
  }

  refreshProfile = () => {
    this.props.dispatch(fetchUserData(false))
  }

  onConfirmPositive = () => {
    this.props.dispatch(actionProcessing(true))

    if (this.state.modalAction === ACTION_DOWNLOAD) {
      this.downloadSiteAction(this.state.domainToAction)
      return
    }

    // Handle different actions with appropriate endpoints
    let endpoint, payload

    const path =
      this.state.modalAction.toLowerCase().includes('delete/account') ||
      this.state.modalAction.toLowerCase().includes('download')
        ? '/pro/'
        : '/v3/site/'

    if (this.state.modalAction === ACTION_DELETE) {
      endpoint = `${API_ROOT}/v3/site/trash`
      payload = {
        email: this.props.userProfile.email,
        domain: this.state?.domainToAction?.subdomain || this.state?.domainToAction?.link
      }
    } else if (this.state.modalAction === ACTION_RESTORE_DELETED) {
      endpoint = `${API_ROOT}/v3/site/trash/restore`
      payload = {
        domain: this.state?.domainToAction?.subdomain || this.state?.domainToAction?.link
      }
    } else if (this.state.modalAction === ACTION_PERMANENT_DELETE) {
      endpoint = `${API_ROOT}/v3/site/delete`
      payload = {
        domain: this.state?.domainToAction?.subdomain || this.state?.domainToAction?.link,
        site: this.state.domainToAction
      }
    } else if (this.state.modalAction === ACTION_DELETE_ACCOUNT) {
      endpoint = `${API_ROOT}/v3/account/delete`
      payload = {}
    } else {
      endpoint = `${API_ROOT}${path}${this.state.modalAction.toLowerCase()}`
      payload = {
        domain: this.state?.domainToAction?.subdomain || this.state?.domainToAction?.link,
        site: this.state.domainToAction
      }
    }

    api
      .post(endpoint, payload)
      .then((res) => {
        this.props.dispatch(fetchUserData(false))
        this.setState({
          modalConfirmationShow: false
        })
        this.props.dispatch(actionProcessing(false))

        if (this.state.modalAction === ACTION_DELETE_ARCHIVE) {
          this.props.dispatch(showMessageModal({ title: 'Site deleted', message: 'Your site has been deleted.' }))
        } else if (this.state.modalAction === ACTION_RESTORE_ARCHIVE) {
          const restoredSite = res.data?.site
          if (restoredSite?.inPreviewMode) {
            this.props.dispatch(setPreviewModal(true))
            this.props.dispatch(setPreviewData(restoredSite))
          } else {
            this.props.dispatch(setFirstTimeSuccModal({ showFistTimeSuccModal: true, firstTimeSite: restoredSite }))
          }
        } else if (this.state.modalAction === ACTION_RESTORE_DELETED) {
          this.props.dispatch(fetchDeletedSites())
          const restoredSite = res.data?.site || res.data
          if (restoredSite?.inPreviewMode) {
            this.props.dispatch(setPreviewModal(true))
            this.props.dispatch(setPreviewData(restoredSite))
          } else {
            this.props.dispatch(setFirstTimeSuccModal({ showFistTimeSuccModal: true, firstTimeSite: restoredSite }))
          }
        } else if (this.state.modalAction === ACTION_PERMANENT_DELETE) {
          this.props.dispatch(fetchDeletedSites())
          const domain = this.state?.domainToAction?.subdomain || this.state?.domainToAction?.link || 'Site'
          this.props.dispatch(
            showMessageModal({
              title: 'Site permanently deleted',
              message: `${domain} has been permanently deleted.`
            })
          )
        }
      })
      .catch(() => {
        this.props.dispatch(actionProcessing(false))
        // show error toast
      })
  }

  onConfirmNegative = () => {
    this.setState({
      modalConfirmationShow: false
    })
  }

  onDelete = (site) => {
    if (site.linkStatus === 'processing') {
      if (site.created) {
        const createdTime = new Date(site.created)
        const currentTime = new Date()
        const timeDifference = (currentTime - createdTime) / (1000 * 60) // Convert milliseconds to minutes

        if (timeDifference < 30) {
          this.props.dispatch(
            showMessageModal({
              title: "This project can't be deleted yet.",
              message:
                'Processing files can only be deleted 30 minutes after their upload. This is done to ensure that your file gets correctly uploaded.'
            })
          )
          return
        }
      }
    }
    if (site?.subdomain.includes('tiiny.io')) {
      this.setState({
        modalAction: ACTION_DELETE,
        modalConfirmationShow: true,
        domainToAction: site,
        confirmMessage: `Are you sure you want to move ${(!site.inPreviewMode && site.subdomain) || 'this site'} to the trash?`
      })
      return
    }
    this.setState({
      domainToAction: site,
      showArchiveDelete: true,
      confirmMessage: `
        <div style="text-align: left;">
          <p style="margin: 0; font-size: 16px">You can archive files and download/restore them in the future. Archived files do not count towards your project limit</p>
        </div>
      `
    })
  }

  onReplace = (site) => {
    this.setState({
      domainToAction: site,
      showReplaceUpgrade: true,
      confirmMessage: `
        <div style="text-align: left;">
          <p style="margin: 0; font-size: 16px">On the current plan you're allowed to have 1 live project. You can replace your current project with a new one and remain on the free plan. </p>
        </div>
      `
    })
  }

  onArchive = (site) => {
    const { userProfile, archivedSites, dispatch } = this.props
    const isFreeUser = !userProfile.productId
    const archivedCount = archivedSites.length

    if (!isFreeUser || archivedCount < ARCHIVE_LIMIT_FREE_PLAN) {
      this.setState({
        modalAction: ACTION_ARCHIVE,
        modalConfirmationShow: true,
        domainToAction: site,
        confirmMessage: `Are you sure you want to archive ${site?.subdomain}?`
      })
    } else {
      dispatch(
        showUpgradeCardModal({
          title: 'Upgrade for unlimited archived files',
          desc: 'On the free plan, you can archive up to 3 projects. Our paid plans allow unlimited archives.',
          cta: 'Upgrade now',
          onClick: () => onUpgradePlan({ planId: PLANS.TINY.id, userProfile }, dispatch)
        })
      )
    }
  }

  onEdit = (site) => {
    this.setState({
      showFileList: true,
      domainToAction: site
    })
  }

  onFileToEditSelected = (file) => {
    this.setState({
      showFileList: false,
      showCodeEditor: true,
      fileToEdit: file
    })
  }

  onEmbed = (site) => {
    const { dispatch } = this.props
    dispatch(setEmbedData(true, site))
  }

  onDeleteArchive = (site) => {
    this.setState({
      modalAction: ACTION_DELETE_ARCHIVE,
      modalConfirmationShow: true,
      domainToAction: site,
      confirmMessage: `Are you sure you want to delete archive ${site?.subdomain}?`
    })
  }

  onRestoreArchive = (site) => {
    // check site limit before restoration
    const { userProfile, liveSites, dispatch } = this.props
    const siteLimit = userProfile?.siteLimit

    if (siteLimit <= liveSites.length) {
      dispatch(
        showUpgradeCardModal({
          title: 'Upgrade to upload more content',
          desc: `Your current plan only allows ${siteLimit} live ${pluralize(
            'project',
            'projects',
            siteLimit
          )}. Upload more on a different plan.`,
          cta: 'Create more projects',
          onClick: () => onUpgradePlan({ projects: siteLimit }, dispatch)
        })
      )
      return
    } else {
      this.setState({
        modalAction: ACTION_RESTORE_ARCHIVE,
        modalConfirmationShow: true,
        domainToAction: site,
        confirmMessage: `
          <div style="text-align: center;">
            <h4 style="font-size: 21px; margin-bottom: 12px;">Unarchive Project?</h4>
            <p style="margin: 0; font-size: 16px">Unarchiving this project <u>${site?.subdomain}</u> will reactivate the link to your files</p>
          </div>
        `
      })
    }
  }

  onRestoreDeleted = (domain) => {
    const { userProfile, liveSites, dispatch } = this.props
    const siteLimit = userProfile?.siteLimit

    if (siteLimit <= liveSites.length) {
      dispatch(
        showUpgradeCardModal({
          title: 'Upgrade to upload more content',
          desc: `Your current plan only allows ${siteLimit} live ${pluralize(
            'project',
            'projects',
            siteLimit
          )}. Upload more on a different plan.`,
          cta: 'Create more projects',
          onClick: () => onUpgradePlan({ projects: siteLimit }, dispatch)
        })
      )
      return
    }

    this.setState({
      modalAction: ACTION_RESTORE_DELETED,
      modalConfirmationShow: true,
      domainToAction: { subdomain: domain },
      confirmMessage: `Are you sure you want to restore ${domain}? This will move it back to your live sites.`
    })
  }

  onPermanentlyDelete = (domain) => {
    this.setState({
      modalAction: ACTION_PERMANENT_DELETE,
      modalConfirmationShow: true,
      domainToAction: { subdomain: domain },
      confirmMessage: `Are you sure you want to permanently delete ${domain}? This action cannot be undone.`
    })
  }

  downloadSiteAction = (site) => {
    downloadSite({ domain: site.subdomain }, { responseType: 'arraybuffer' })
      .then((response) => {
        const contentDisposition = response.headers['content-disposition']
        let filename = response.headers['x-filename']

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/)
          if (match && match[1]) {
            filename = match[1] // Extract filename from header if available
          }
        }

        // Initiate download with the provided filename and content type
        const contentType = response.headers['content-type'] || 'application/octet-stream'
        download(response.data, filename, contentType)
        this.setState({
          modalConfirmationShow: false
        })
        this.props.dispatch(actionProcessing(false))
      })
      .catch(() => {
        this.props.dispatch(
          showMessageModal({
            title: 'Download failed',
            message: 'Unable to download site, please contact support.',
            error: true
          })
        )
      })
  }

  onDownload = (site) => {
    this.setState({
      modalAction: ACTION_DOWNLOAD, // Set the action to DOWNLOAD
      modalConfirmationShow: true, // Show the confirmation modal
      domainToAction: site, // Store the site to be downloaded
      confirmMessage: `Are you sure you want to download ${site.subdomain}?` // Set the confirmation message
    })
  }

  onDownloadAll = async (site) => {
    if (!site?.subdomain && !site?.link) return

    this.setState({ downloadAllProcessing: true })
    this.props.dispatch(actionProcessing(true))

    try {
      await executeDownloadAll(site, {
        onError: (message) => this.props.dispatch(showMessageModal({ title: 'Download failed', message, error: true })),
        onTimeout: () =>
          this.props.dispatch(
            showMessageModal({
              title: 'Download failed',
              message: 'The zip could not be prepared in time. Please try again.',
              error: true
            })
          )
      })
    } finally {
      this.setState({ downloadAllProcessing: false })
      this.props.dispatch(actionProcessing(false))
    }
  }

  showUpgradeView = (trial) => {
    if (trial) {
      this.props.dispatch(showSubscribeModal(true))
    } else {
      this.setState({ showUpgradeModal: true })
    }
    openPricingPopup()
  }

  onAnalytics = (site) => {
    this.props.dispatch(showAnalyticsModal({ analyticsType: analyticsTypes.ANALYTICS, site }))
  }

  onAnalyseSite = (site) => {
    this.props.dispatch(showHtmlAnalysisModal(site))
  }

  onEditPDF = (fileLink) => {
    this.setState({
      showPDFEditor: true,
      pdfUrlToEdit: fileLink
    })
  }

  onOpenTextEditor = (site) => {
    this.setState({
      showTextEditor: true,
      siteToAction: site
    })
  }

  onOpenGithubModal = () => {
    this.setState({ showGitHubModal: true })
  }

  onOpenTransferRequestLinkModal = () => {
    this.setState({
      showTransferRequestLinkModal: true
    })
  }

  onOpenDropBox = () => {
    this.props.dispatch(showDropboxModal(true))
  }

  onQRCode = (site) => {
    const { dispatch, userProfile } = this.props

    if (userProfile?.productId && site) {
      dispatch(setQrCodeModal(true))
      dispatch(setQrCodeData(site))
    } else {
      dispatch(
        showUpgradeCardModal({
          ...UPGRADE_QR_PAYLOAD,
          onClick: () => onUpgradePlan({ planId: PLANS.TINY.id, userProfile }, dispatch)
        })
      )
    }
  }

  onPreview = (site) => {
    const { dispatch, history } = this.props
    uploadedFileTooBig()
    history.push(DEEP_LINK.PREVIEW_MODE)
    dispatch(setPreviewModal(true))
    dispatch(setPreviewData(site))
  }

  onDeleteAccount = () => {
    this.setState({
      modalAction: ACTION_DELETE_ACCOUNT,
      modalConfirmationShow: true,
      confirmMessage: `Are you sure you want to delete your account & links?`
    })
  }

  onOpenUrl = async () => {
    try {
      await openGithubConnect()
    } catch {
      this.props.dispatch(
        showMessageModal({
          title: "Couldn't connect GitHub",
          message: "We couldn't start the GitHub connection. Please try again.",
          error: true
        })
      )
    }
  }

  onViewVersions = async (site) => {
    const { dispatch, userProfile } = this.props

    if (isOnFreeTrial(userProfile)) {
      addUpgradeReason(UPGRADE_VERSIONS_PAYLOAD.title)
      this.setState({ showVersionsTrialUpgrade: true })
      return
    }

    if (!userProfile?.productId) {
      dispatch(
        showUpgradeCardModal({
          ...UPGRADE_VERSIONS_PAYLOAD,
          onClick: () => onUpgradePlan({ planId: PLANS.TINY.id, userProfile }, dispatch)
        })
      )
      return
    }

    const domain = site?.subdomain || site?.link
    if (!domain) return

    this.setState({
      showVersionsModal: true,
      versionsLoading: true,
      versionsData: [],
      versionsSite: site,
      activeVersionId: null,
      selectedVersionId: null
    })

    try {
      const res = await getSiteVersions(domain)
      const versions = res?.data?.versions || []
      const activeVersionId = res?.data?.activeVersionId || versions.find((version) => version.isActive)?.id || null
      this.setState({
        versionsData: versions,
        activeVersionId,
        selectedVersionId: activeVersionId,
        versionsLoading: false
      })
    } catch (error) {
      this.setState({ versionsLoading: false })
      this.props.dispatch(
        showMessageModal({
          title: 'Failed to load versions',
          message: error?.response?.data?.message || 'Unable to load site versions right now.',
          error: true
        })
      )
    }
  }

  onRollbackVersion = async () => {
    const { versionsSite, selectedVersionId } = this.state
    const domain = versionsSite?.subdomain || versionsSite?.link
    if (!domain || !selectedVersionId) return

    this.setState({ versionsRollbackProcessing: true })

    try {
      await rollbackSiteVersion({
        domain,
        versionId: selectedVersionId
      })

      this.setState({
        versionsRollbackProcessing: false,
        showVersionsModal: false,
        versionsData: [],
        versionsSite: null,
        activeVersionId: null,
        selectedVersionId: null
      })

      this.props.dispatch(fetchUserData(false))
      this.props.dispatch(
        showMessageModal({
          title: 'Version restored',
          message: `${domain} has been rolled back and reprocessed successfully.`
        })
      )
    } catch (error) {
      this.setState({ versionsRollbackProcessing: false })
      this.props.dispatch(
        showMessageModal({
          title: 'Rollback failed',
          message: error?.response?.data?.message || 'Unable to rollback this version right now.',
          error: true
        })
      )
    }
  }

  onOptionModal = (site, action) => {
    this.setState({
      domainToAction: site,
      showOptionsModal: true,
      optionAction: action
    })
  }

  onAddCustomDomain = (site) => {
    const { userProfile } = this.props

    if (!hasFeature(this.props.userProfile?.productId, F_CUSTOM_DOMAIN)) {
      this.props.dispatch(
        showUpgradeCardModal({
          ...UPGRADE_CUSTOM_DOMAIN,
          onClick: () =>
            onUpgradePlan({ planId: PLANS.PRO.id, userProfile: this.props.userProfile }, this.props.dispatch)
        })
      )
    } else if (this.props.userProfile?.siteLimit === this.props.userProfile?.customDomains?.length) {
      this.props.dispatch(showMessageModal({ title: 'Limit reached', message: 'Custom domain limit reached' }))
    } else {
      const siteDomain = site?.subdomain || site?.link
      const isPhpSite = siteDomain?.includes('tiiny.io') || isWasmerFile(site)

      if (isPhpSite) {
        localStorage.setItem('isServerFileForCustomDomain', 'true')
        if (site?.wasmerDnsRecord) {
          const wasmerData = site.wasmerDnsRecord
          const records = formatWasmerRecords(wasmerData)
          const transformedData = {
            domain: site.wasmerCustomDomain,
            isPhpDomain: true,
            phpDomainData: wasmerData,
            records: records
          }
          this.props.dispatch(showCustomDomainModal({ show: true, data: transformedData }))
        } else {
          if (site?.subdomain) {
            localStorage.setItem('publishToCustomDomain', site.subdomain)
          }
          this.props.dispatch(showCustomDomainModal(true))
        }
      } else {
        localStorage.removeItem('isServerFileForCustomDomain')
        this.props.dispatch(showCustomDomainModal(true))
      }
    }
  }

  customDomainDiagnostics = (site) => {
    // Todo: for custom domain diagnostics deep link
    this.onAddCustomDomain(site)
    this.props.dispatch(customDomainDiagnostics(site))
  }

  onCloseProjectSelectorModal = () => {
    this.setState({
      showDomainUpdateModal: false,
      domainToUpdate: null
    })
    this.props.history.replace({ pathname: '/manage' })
  }

  onSelectProjectForDomain = (selectedSite) => {
    const { domainToUpdate } = this.state
    if (domainToUpdate && selectedSite) {
      // Set up localStorage for publishing to custom domain
      localStorage.setItem('active_custom_domain', `.${domainToUpdate.domain}`)
      localStorage.setItem('active_custom_subdomain', domainToUpdate?.subdomain ? domainToUpdate?.subdomain : 'www')

      // Close the modal
      this.setState({
        showDomainUpdateModal: false,
        domainToUpdate: null
      })

      // Trigger site update action
      this.onSiteAction(ACTION_UPDATE, selectedSite)
    }
  }

  onCloseClaimSiteModal = () => {
    this.setState({ showClaimSiteModal: false })
  }

  render() {
    const {
      fileToEdit,
      modalConfirmationShow,
      confirmMessage,
      domainToAction,
      optionAction,
      showFileList,
      showCodeEditor,
      showArchiveDelete,
      showReplaceUpgrade,
      showTextEditor,
      showOptionsModal,
      showClaimSiteModal,
      showGitHubModal,
      showTransferRequestLinkModal,
      showVersionsModal,
      showVersionsTrialUpgrade,
      versionsLoading,
      versionsRollbackProcessing,
      versionsData,
      activeVersionId,
      selectedVersionId,
      versionsSite
    } = this.state
    const {
      dispatch,
      accountModalVisible,
      liveSites = [],
      modalMessageData,
      showMessageModal,
      archivedSites,
      userProfile = {},
      actionProcessing,
      fetchingUser,
      customDomains,
      showTeamModal,
      showSelectTeamOwnerModal,
      selectTeamOwnerData,
      members,
      history,
      showFistTimeSuccModal,
      firstTimeSite,
      showQRCodeModal,
      QRCodeData,
      showPreviewModal,
      previewData,
      embedData,
      showPaymentModal,
      showProPlans,
      upgradePlanId,
      periodProp,
      googleReCaptchaProps,
      showAccountPasswordModal,
      modalEmailSubscriptionVisible,
      emailSubscriptionDomain,
      trackedModalPayload,
      analyticsModalPayload,
      htmlAnalysisModalPayload,
      isPresignedUploadInProgress,
      githubData,
      dropboxModalVisible
    } = this.props

    const trialAccount = !userProfile.productId
    const classification = liveSites[0]?.classification
    const unsubmittedEligibleGameSites = getUnsubmittedEligibleGameSites(liveSites, this.state.gameShowcaseStatuses)
    const siteLimit = trialAccount ? 1 : userProfile.siteLimit || 5
    const liveSitesCount = liveSites.length
    const connectGithub = !isGithubConnected(githubData)
    const viewRepos = isGithubConnected(githubData)

    return (
      <DragWrapper trialAccount={trialAccount} siteLimit={siteLimit} liveSites={liveSites}>
        <DropboxConnector
          onFileReady={() => {
            this.onSiteAction(ACTION_CREATE)
            dispatch(showDropboxModal(false))
          }}
          showExplorerModal={dropboxModalVisible}
          onHide={() => dispatch(showDropboxModal(false))}
        />
        <div className="full-height pb-5">
          <GlobalTiinyReceiver />
          <FirstTimeSucessModal
            show={showFistTimeSuccModal}
            onHide={() => dispatch(setFirstTimeSuccModal({ showFistTimeSuccModal: false, firstTimeSite: {} }))}
            domain={firstTimeSite?.subdomain ? firstTimeSite : liveSites[0]}
            userProfile={userProfile}
            onSiteAction={(actionState, siteToAction) => this.onSiteAction(actionState, siteToAction)}
          />
          {userProfile?.productId === PLANS.API.id && <APIWelcomeModal apiKey={userProfile?.apiKey} />}
          <ManageAccountModal
            show={accountModalVisible}
            onHide={() => dispatch(accountModal(false))}
            onUpgrade={() => onUpgradePlan({ planId: userProfile?.productId, userProfile }, dispatch)}
          />
          {trackedModalPayload.site && <TrackedLinkCreateModal />}
          {analyticsModalPayload.site && (
            <AnalyticsModal
              trialMode={trialAccount}
              onUpgradeCTA={(tab) =>
                onUpgradePlan({ planId: tab === 'tracked' ? PLANS.PRO.id : PLANS.TINY.id, userProfile }, dispatch)
              }
            />
          )}
          {htmlAnalysisModalPayload?.site && <HtmlAnalysisModal site={htmlAnalysisModalPayload.site} />}
          <OptionsModal
            show={showOptionsModal}
            onClose={() => this.setState({ showOptionsModal: false })}
            userProfile={userProfile}
            site={domainToAction}
            onEditPDF={this.onEditPDF}
            action={optionAction}
          />
          <VersionsModal
            show={showVersionsModal}
            onHide={() =>
              this.setState({
                showVersionsModal: false,
                versionsData: [],
                versionsSite: null,
                activeVersionId: null,
                selectedVersionId: null,
                versionsLoading: false,
                versionsRollbackProcessing: false
              })
            }
            site={versionsSite}
            versions={versionsData}
            activeVersionId={activeVersionId}
            loading={versionsLoading}
            rollbackProcessing={versionsRollbackProcessing}
            selectedVersionId={selectedVersionId}
            onSelectVersion={(versionId) => this.setState({ selectedVersionId: versionId })}
            onRollback={this.onRollbackVersion}
          />
          <UpgradePromptModal
            show={showVersionsTrialUpgrade}
            onHide={() => this.setState({ showVersionsTrialUpgrade: false })}
            userProfile={userProfile}
            dispatch={dispatch}
            title="This feature isn't available on the trial"
            description="Upgrade your account to see previous versions of your projects."
            confirmDescription={(planName) =>
              `Please confirm you want to upgrade now to the ${planName} plan to see previous versions.`
            }
            successMessage={(planLabel) =>
              `Your account has been upgraded to ${planLabel}. You can now see previous versions of your projects.`
            }
          />
          <CreateUpdateSiteModal
            sites={liveSites}
            disableProFeatures={trialAccount}
            liveSitesCount={liveSitesCount}
            executeRecaptcha={googleReCaptchaProps?.executeRecaptcha}
            onReplace={this.onReplace}
            onShowCodeEditor={this.onShowCodeEditor}
            onOpenTextEditor={this.onOpenTextEditor}
            onOpenUrl={this.onOpenUrl}
            onOpenGithubModal={this.onOpenGithubModal}
            onOpenTransferRequestLinkModal={this.onOpenTransferRequestLinkModal}
            onOpenDropBox={this.onOpenDropBox}
            viewRepos={viewRepos}
          />
          <ConfirmationModal
            title="Delete site"
            message={confirmMessage}
            show={modalConfirmationShow}
            handlePositive={this.onConfirmPositive}
            handleNegative={this.onConfirmNegative}
            actionProcessing={actionProcessing}
          />
          <DomainExistsModal />
          <ArchiveDeleteModal
            message={confirmMessage}
            show={showArchiveDelete}
            onClose={() => this.setState({ showArchiveDelete: false, domainToAction: null })}
            domain={domainToAction}
            title="Delete or Archive?"
          />
          <ReplaceUpgradeModal
            message={confirmMessage}
            show={showReplaceUpgrade}
            onClose={() => this.setState({ showReplaceUpgrade: false, domainToAction: null })}
            domain={domainToAction}
            onSiteAction={this.onSiteAction}
            title="Replace or Upgrade?"
            executeRecaptcha={googleReCaptchaProps?.executeRecaptcha}
          />
          <MessageModal
            show={showMessageModal}
            handleNeutral={() => dispatch(hideMessageModal())}
            {...modalMessageData}
          />
          <Modal
            show={this.state.downloadAllProcessing}
            centered
            backdrop="static"
            keyboard={false}
            aria-labelledby="download-all-loading"
          >
            <Modal.Body className="text-center py-4 px-4">
              <Spinner animation="border" className="mb-3" />
              <p className="mb-0">Preparing your zip...</p>
            </Modal.Body>
          </Modal>
          <FileListModal
            domain={domainToAction}
            show={showFileList}
            onHide={() => this.setState({ showFileList: false })}
            onFileSelected={this.onFileToEditSelected}
          />
          <EmbedModal
            show={embedData.show}
            onHide={() => {
              dispatch(setEmbedData(false, ''))
            }}
            domain={embedData.site}
          />
          <QRCodeModal
            show={showQRCodeModal}
            onHide={() => {
              dispatch(setQrCodeModal(false))
            }}
            domain={QRCodeData}
          />
          <PreviewModal
            show={showPreviewModal}
            onHide={() => dispatch(setPreviewModal(false))}
            site={previewData}
            userProfile={userProfile}
            liveSitesCount={liveSitesCount}
          />
          <AccountPasswordModal
            show={showAccountPasswordModal}
            onHide={() => dispatch(setAccountPasswordModal(false))}
            userProfile={userProfile}
          />
          <ProjectSelectorModal
            show={this.state.showDomainUpdateModal}
            onHide={this.onCloseProjectSelectorModal}
            onSelectProject={this.onSelectProjectForDomain}
            customDomain={
              this.state.domainToUpdate?.subdomain
                ? `${this.state.domainToUpdate.subdomain}.${this.state.domainToUpdate.domain}`
                : this.state.domainToUpdate?.domain
            }
          />
          <PlanPaymentModal
            show={showPaymentModal}
            onHide={() => {
              dispatch(setShowPaymentModal({ showPaymentModal: false, upgradePlanId: null }))
              this.refreshProfile()
            }}
            planId={upgradePlanId}
            periodProp={periodProp}
            history={history}
          />
          <AddTeamMembersModal
            show={showTeamModal}
            onHide={() => {
              dispatch(toggleTeamModal(false))
              this.refreshProfile()
            }}
            userProfile={userProfile}
            currentTeamMembers={members}
          />
          <SelectTeamOwnerModal
            show={showSelectTeamOwnerModal}
            teamOwners={selectTeamOwnerData}
            onHide={() => dispatch(toggleSelectTeamOwnerModal({ show: false, teamOwners: [] }))}
            onSuccess={() => {
              dispatch(toggleSelectTeamOwnerModal({ show: false, teamOwners: [] }))
              this.refreshProfile()
            }}
          />
          <PDFEditorModal
            document={this.state.pdfUrlToEdit}
            show={this.state.showPDFEditor}
            onClose={() =>
              this.setState({
                showPDFEditor: undefined,
                pdfUrlToEdit: undefined
              })
            }
            trial={!hasFeature(userProfile.productId, F_EDIT_MODE)}
            onUpgrade={() => onUpgradePlan({ planId: PLANS.PRO.id, userProfile }, dispatch)}
          />
          <ClaimSiteModal
            userProfile={this.props.userProfile}
            liveSitesCount={liveSitesCount}
            onClose={this.onCloseClaimSiteModal}
            show={showClaimSiteModal}
          />
          <Suspense fallback={<div />}>
            <TextEditor
              show={showTextEditor}
              onHide={() => this.setState({ showTextEditor: false, siteToAction: false })}
              onSiteAction={(actionState, siteToAction) => this.onSiteAction(actionState, siteToAction)}
              setDraggedFile={(file) => dispatch(setDraggedFile(file))}
              setSiteType={(siteType) => dispatch(setSiteType(siteType))}
              siteToAction={this.state.siteToAction}
            />
          </Suspense>
          <Suspense fallback={<div />}>
            <CodeEditor
              show={showCodeEditor}
              onHide={() => this.setState({ showCodeEditor: false })}
              file={fileToEdit}
              domain={domainToAction}
              onSiteAction={this.onSiteAction}
              setDraggedFile={(file) => dispatch(setDraggedFile(file))}
              disableRouting={true}
            />
          </Suspense>
          <Refund />
          <RepoModal
            show={showGitHubModal}
            onHide={() => this.setState({ showGitHubModal: false })}
            userProfile={userProfile}
            liveSitesCount={liveSitesCount}
            onUpdate={(site) => {
              this.onSiteAction(ACTION_UPDATE, site)
            }}
          />
          <TransferRequestLinkModal
            show={showTransferRequestLinkModal}
            onHide={() => this.setState({ showTransferRequestLinkModal: false })}
            userProfile={userProfile}
            customDomains={customDomains}
            activeSpace={this.props.activeSpace}
          />
          <EmailSubscriptionModal
            show={modalEmailSubscriptionVisible}
            domain={emailSubscriptionDomain}
            onHide={() => dispatch(showEmailSubscriptionModal(false))}
          />
          <DiscountBanner
            onUpgrade={() => {
              onUpgradePlan({ planId: PLANS.TINY.id, userProfile }, dispatch)
              localStorage.setItem('discount-code', 'ILwFIMwL')
            }}
            userProfile={userProfile}
          />
          <AIPlatformBanner />
          <HomeHeader
            email={userProfile.email}
            productCode={userProfile.productCode}
            onUpgrade={() => onUpgradePlan({ planId: userProfile?.productId, userProfile }, dispatch)}
            showUpgradePayModal={() => onUpgradePlan({ planId: PLANS.PRO_U.id, userProfile }, dispatch)}
            showDeleteAccountModal={this.onDeleteAccount}
            proMode
          />
          <UpgradePromoCard onClick={() => dispatch(showSubscribeModal(true))} trialAccount={trialAccount} />
          <FeedbackCallModal userCreatedTime={userProfile?.created} />
          <FreeTrialModalContainer
            userProfile={userProfile}
            liveSites={liveSites}
            previewData={previewData}
            dispatch={dispatch}
            setFirstTimeSuccModal={setFirstTimeSuccModal}
          />
          {<ProPlansModal email={userProfile.email} showProPlans={showProPlans} dispatch={dispatch} />}
          {fetchingUser ? (
            <Spinner className="mt-5" animation="border" variant="dark" />
          ) : (
            <>
              <div className={`container-manage ${trialAccount ? '' : 'd-block'}`}>
                <div className={`container-manage-left${trialAccount ? '' : '-full'}`}>
                  <BandwidthAlert
                    pageViews={userProfile.pageViews}
                    bandwidth={userProfile.bandwidth}
                    productId={userProfile.productId}
                    resetDate={userProfile.created}
                    usage_alert={userProfile.usage_alert}
                  />

                  <SubscriptionPausedAlert profile={userProfile} refreshProfile={this.refreshProfile} />
                  <SubscriptionSuspendedModal profile={userProfile} />
                  <PastDuePaymentModal profile={userProfile} />
                  <ProcessingFilesAlert show={isPresignedUploadInProgress} />
                  <AICreatorBanner userProfile={userProfile} />
                  <JoinTeamBanner userProfile={userProfile} />
                  <GameShowcaseBanner
                    site={unsubmittedEligibleGameSites[0]}
                    onSubmit={() => this.setState({ gameShowcaseSites: unsubmittedEligibleGameSites })}
                  />
                  <GameShowcaseModal
                    show={!!this.state.gameShowcaseSites.length}
                    sites={this.state.gameShowcaseSites}
                    onHide={() => {
                      this.setState({ gameShowcaseSites: [] })
                      this.refreshGameShowcaseStatuses()
                    }}
                  />
                  <h2 className="text-center text-lg-start bold font-24 d-md-block d-none">My Account</h2>
                  <ProjectViews
                    history={history}
                    location={this.props.location}
                    sites={liveSites}
                    archivedSites={archivedSites}
                    userProfile={userProfile}
                    onDelete={this.onDelete}
                    onViewVersions={this.onViewVersions}
                    onDownload={this.onDownload}
                    onDownloadAll={this.onDownloadAll}
                    onEdit={this.onEdit}
                    onSiteAction={this.onSiteAction}
                    onArchive={this.onArchive}
                    onAnalytics={this.onAnalytics}
                    trialAccount={trialAccount}
                    onQRCode={this.onQRCode}
                    onPreview={this.onPreview}
                    onEditPDF={this.onEditPDF}
                    onEmbed={this.onEmbed}
                    onShare={(site) => {
                      this.onOptionModal(site, ACTION_SHARE)
                    }}
                    onUpdate={(site) => {
                      this.onOptionModal(site, ACTION_UPDATE)
                    }}
                    onOpenTextEditor={this.onOpenTextEditor}
                    onShowCodeEditor={() => this.setState({ showCodeEditor: true })}
                    onAddCustomDomain={this.onAddCustomDomain}
                    siteLimit={siteLimit}
                    connectGithub={connectGithub}
                    viewRepos={viewRepos}
                    onOpenGithubModal={this.onOpenGithubModal}
                    onOpenTransferRequestLinkModal={this.onOpenTransferRequestLinkModal}
                    onOpenUrl={this.onOpenUrl}
                    onOpenDropBox={this.onOpenDropBox}
                    onDeleteArchive={this.onDeleteArchive}
                    onRestoreArchive={this.onRestoreArchive}
                    onRestoreDeleted={this.onRestoreDeleted}
                    onPermanentlyDelete={this.onPermanentlyDelete}
                    dispatch={dispatch}
                    customDomains={customDomains}
                    refreshProfile={this.refreshProfile}
                    classification={classification}
                    onOpenEmailSubscription={(domain) => {
                      this.props.dispatch(showEmailSubscriptionModal(true, domain))
                    }}
                    onAnalyseSite={this.onAnalyseSite}
                    onSubmitGame={(site) => this.setState({ gameShowcaseSites: [site] })}
                    gameShowcaseStatuses={this.state.gameShowcaseStatuses}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </DragWrapper>
    )
  }
}

const mapStateToProps = ({ manage, upgrade, modals }) => ({
  userProfile: manage.userProfile,
  archivedSites: manage.archivedSites,
  customDomains: manage.customDomains,
  members: manage.members?.map((m) => m.email),
  liveSites: manage.liveSites,
  actionProcessing: manage.actionProcessing,
  fetchingUser: manage.fetchingUser,
  accountModalVisible: manage.accountModalVisible,
  dropboxModalVisible: manage.dropboxModalVisible,
  showProPlans: manage.upgradeModalVisible,
  modalMessageData: manage.modalMessageData,
  showMessageModal: manage.showMessageModal,
  showTeamModal: manage.showTeamModal,
  showSelectTeamOwnerModal: manage.showSelectTeamOwnerModal,
  selectTeamOwnerData: manage.selectTeamOwnerData,
  showFistTimeSuccModal: manage.showFistTimeSuccModal,
  firstTimeSite: manage.firstTimeSite,
  QRCodeData: manage.QRCodeData,
  showQRCodeModal: manage.showQRCodeModal,
  embedData: manage.embedData,
  showPreviewModal: manage.showPreviewModal,
  showAccountPasswordModal: manage.showAccountPasswordModal,
  modalEmailSubscriptionVisible: manage.modalEmailSubscriptionVisible,
  emailSubscriptionDomain: manage.emailSubscriptionDomain,
  previewData: manage.previewData,
  showPDFEditorModal: manage.showPDFEditorModal,
  isPresignedUploadInProgress: manage.isPresignedUploadInProgress,
  showPaymentModal: upgrade.showPaymentModal,
  upgradePlanId: upgrade.upgradePlanId,
  trackedModalPayload: modals.trackedModalPayload,
  analyticsModalPayload: modals.analyticsModalPayload,
  htmlAnalysisModalPayload: modals.htmlAnalysisModalPayload,
  githubData: manage.githubData,
  periodProp: upgrade.periodProp,
  activeSpace: manage.activeSpace
})

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(withGoogleReCaptcha(withRouter(Manage)))
